module.exports = __webpack_public_path__ + "img/Uneven Plating.e7bc64b5.png";